import React from 'react';
import clsx from 'clsx';
import MuiTimelineDot from '@material-ui/lab/TimelineDot';
import type { TimelineDotProps as MuiProps } from '@material-ui/lab/TimelineDot';
import { capitalize } from '@material-ui/core/utils';
import useStyles from './styles';

type ColorType = 'inherit' | 'primary' | 'secondary' | 'grey';

type SeverityType = 'info' | 'success' | 'warning' | 'error';

export interface TimelineDotProps extends MuiProps {
    /**
     * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
     */
    color?: ColorType;
    /**
     * The severity of the dot. This defines the color and icon used.
     */
    severity?: SeverityType;
}

const TimelineDot: React.FC<TimelineDotProps> = (props) => {
    const { className, severity, variant, color, ...rest } = props;
    const classes = useStyles();

    let classNameMerged = className;

    if (severity) {
        classNameMerged = clsx(
            {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                [classes[`${variant}${capitalize(severity)}`]]: severity,
            },
            className,
        );
    }

    return <MuiTimelineDot className={classNameMerged} variant={variant} color={color} {...rest} />;
};

TimelineDot.defaultProps = {
    variant: 'default',
};

export default TimelineDot;
